import { useContext, useState, useRef, useEffect } from "react";
import { Link } from 'react-router-dom';

import { DataContext } from "providers/DataProvider";
import { useNotificationPermission } from "providers/NotificationPermissionProvider";

import 'styles/Navbar.css';

function NavBar() {

  const { me } = useContext(DataContext);

  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const toggleUserDropdown = () => {setUserDropdownOpen(!userDropdownOpen)};

  const userDropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (userDropdownRef.current && !userDropdownRef.current.contains(event.target)) {
      setUserDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mouseup', handleClickOutside);
    return () => {
      document.removeEventListener('mouseup', handleClickOutside);
    };
  }, []);

  const { notificationsEnabled, toggleNotifications } = useNotificationPermission();

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <Link className="nav-link" to="/">Home</Link>
      </div>
      <div className="navbar-right">
        {me?.email
            ? (<div className="user-identifier">
                <label className="display" onClick={toggleUserDropdown} ref={userDropdownRef}>
                  {me?.name}
                  <div className="pic" style={{backgroundImage: `url(${me?.picture?.imageSrc})`}}/>
                </label>
                <div className="dropdown" style={{display: userDropdownOpen ? 'flex' : 'none'}}>
                  <Link className="nav-link" to="/profile">Profile</Link>
                  <Link className="nav-link" to="/create-activity">Create activity</Link>
                  <Link className="nav-link" to="/create-group">Create group</Link>
                  <Link className="nav-link" to="/logout">Log out</Link>
                  <Link className="nav-link" to="/notifications">Notifications</Link>
                </div>
              </div>)
            : (<>
              <Link className="nav-link" to="/login">Log in</Link>
              <Link className="nav-link" to="/signup">Sign up</Link>
              </>)
        }
      </div>
    </nav>
  );
}

export default NavBar